export const WIDTH_IMAGE = '88px';
export const ASPECT_RATIO_IMAGE = '2/1';
